import React from 'react';
import { Button } from '@material-ui/core';
import { EmptyState } from '@backstage/core-components';

const MissingTokenError = () => /* @__PURE__ */ React.createElement(
  EmptyState,
  {
    missing: "info",
    title: "Missing or invalid PagerDuty Token",
    description: "The request to fetch data needs a valid token. See README for more details.",
    action: /* @__PURE__ */ React.createElement(
      Button,
      {
        color: "primary",
        variant: "contained",
        href: "https://pagerduty.github.io/backstage-plugin-docs/getting-started/pagerduty/"
      },
      "Read More"
    )
  }
);

export { MissingTokenError };
//# sourceMappingURL=MissingTokenError.esm.js.map
